import { FilterOption, Filter } from '../../../components/_WMS/FilterComponent/types'//'../../../../components/_WMS/FilterComponent/types'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'typePositionCode',
    label: 'Código',
    type: 'precreated'
  },
  {
    order: 2,
    key: 'typePositionDescription',
    label: 'Descripción',
    type: 'precreated'
  }
]

export const defaultFilters: Filter[] = []
